import { Check, X } from 'lucide-react';

type ApplicationQualifiedProps = {
  qualified: boolean | null;
};

const ApplicationQualified = ({ qualified }: ApplicationQualifiedProps) => {
  if ([null, undefined, true].includes(qualified)) {
    return (
      <div className="flex justify-center">
        <Check className="text-evaluation-qualified h-6 w-6" />
      </div>
    );
  }

  if (qualified === false) {
    return (
      <div className="flex justify-center">
        <X className="text-evaluation-disqualified h-6 w-6" />
      </div>
    );
  }

  return <div>{' - '}</div>;
};

export default ApplicationQualified;
